<template>
  <component :is="tag" v-bind="{ ...content, ...$attrs }" />
</template>

<script>
import { LoadScript } from '@/utils';

export default {
  props: {
    value: Object
  },
  computed: {
    tag() {
      return this.value.content.tag
    },
    source() {
      return this.value.content.source
    },
    content() {
      return this.value.content.content
    }
  },
  created() {
    LoadScript(this.source, { type: 'module' })
  }
}
</script>

